// Main App Component
import * as React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { AnimatePresence, motion } from 'framer-motion';
import AppBar from './components/layout/AppBar';
import Landing from './pages/Landing/Landing';
import Home from './pages/Home/Home';
import Detail from './pages/Detail/Detail';
import Watch from './pages/Watch/Watch';
import Browse from './pages/Browse/Browse';
import Movies from './pages/Movies/Movies';
import Schedule from './pages/Schedule/Schedule';
import Watchlist from './pages/Watchlist/Watchlist';
import Profile from './pages/Profile/Profile';
import Settings from './pages/Settings/Settings';
import Adult from './pages/Adult/Adult';
import Login from './pages/Login/Login';
import NotFound from './pages/NotFound/NotFound';

const LANDING_ROUTES = ['/'];

export default function App() {
  const theme = useTheme();
  const location = useLocation();
  const isLanding = LANDING_ROUTES.includes(location.pathname);

  return (
    <>
      <CssBaseline />
      {!isLanding && <AppBar />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: '100%',
          mt: isLanding ? 0 : { xs: 8, md: 9 },
          pb: isLanding ? 0 : 4,
          px: isLanding ? 0 : { xs: 2, sm: 3, md: 4 },
          pt: isLanding ? 0 : { xs: 2, sm: 3, md: 4 },
          bgcolor: isLanding ? '#050505' : 'background.default',
          minHeight: '100vh',
        }}
      >
        {isLanding ? (
          <Routes location={location}>
            <Route path="/" element={<Landing />} />
          </Routes>
        ) : (
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3, ease: [0.175, 0.885, 0.32, 1.275] }}
              style={{ width: '100%', maxWidth: '1400px', margin: '0 auto' }}
            >
              <Routes location={location}>
                <Route path="/home" element={<Home />} />
                <Route path="/anime/:id" element={<Detail />} />
                <Route path="/watch/:id" element={<Watch />} />
                <Route path="/browse" element={<Browse />} />
                <Route path="/movies" element={<Movies />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/watchlist" element={<Watchlist />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/adult" element={<Adult />} />
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </motion.div>
          </AnimatePresence>
        )}
      </Box>
    </>
  );
}